<template>
    <v-container grid-list-md text-xs-center style="opacity: 0.8;">
        <v-layout v-if="data" row wrap>
            <v-flex md3 xs12>
                <v-card color="primary" class="white--text" style="padding: 10px; height: 150px;">
                    <h2>{{ !possuiDietas ? "-" : data.dietas.count }}</h2>
                    <h4>{{ strings[idioma].formulacoes }}</h4>
                </v-card>
            </v-flex>
            <v-flex md3 xs12>
                <v-card color="black" class="white--text" style="padding: 10px; height: 150px;">
                    <h2>
                        {{ !possuiPredicoes ? "-" : data.predicoes.count }}
                    </h2>
                    <h4>{{ strings[idioma].predicoes }}</h4>
                </v-card>
            </v-flex>
            <v-flex
                v-if="
                        data &&
                          data.alimentos
                      "
                md3
                xs12
            >
                <v-card color="orange" class="white--text" style="padding: 10px; height: 150px;">
                    <h2>
                        {{ data.alimentos.empresa.count + data.alimentos.usuario.count === 0 ? '-' : data.alimentos.empresa.count + data.alimentos.usuario.count }}
                    </h2>
                    <h4>{{ strings[idioma].alimentos_empresa_pessoal }}</h4>
                </v-card>
            </v-flex>
            <v-flex md3 xs12>
                <v-card color="green" class="white--text" style="padding: 10px; height: 150px;">
                    <h2>{{ data.alimentos.cqbal.count }}</h2>
                    <h4>{{ strings[idioma].alimentos_cqbal }}</h4>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { mapState } from 'vuex';

export default {
    computed: {
            ...mapState("app", [
                "dietasAtivas",
                "data",
                "acesso_premium",
                "strings",
                "idioma",
                "user",
                "ingredientes",
                "optionsNumber",
                "alimentos_selecionados",
                "categorias_alimentos",
                "alimentos_usuario",
                "alert",
                "dietas",
                "predicoes",
                "tabelas",
                "empresa",
                "tabHome",
                "exibeTesteGratis",
            ]),
            predicoesSalvas() {
                return this.predicoes !== null ? this.predicoes.filter((p) => p.user_id === this.user.id) : [];
            },
            possuiPredicoes() {
                return this.predicoes && this.predicoes.length >= 0 && this.predicoesSalvas.length > 0;
            },
            dietasSalvas() {
                return this.dietas !== null ? this.dietas.filter((p) => p.user_id === this.user.id) : [];
            },
            possuiDietas() {
                return this.dietas && this.dietas.length >= 0 && this.dietasSalvas.length > 0;
            },
            heightOverflow() {
                return "max-height: " + String(this.$vuetify.breakpoint.height - 50) + "px; overflow: auto;";
            },
        },
}
</script>
